/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";

const useStore = () => {
    //ID PARA DELEÇÃO
    const [deletarId, setDeletarId] = useState(0);

    return {
        setDeletarId,
        deletarId,
    }
};

export default useStore;